import styled from 'styled-components';
import { Link as RRLink } from 'react-router-dom';

export default styled(RRLink)`
  color: #008fe5;
  text-decoration: none;
`;
